import { useEffect } from 'react';
import {
  BookingFormType,
  FormBookingType,
} from '../../../redux/types/bookingTypes';
import ru from 'react-phone-input-2/lang/ru.json';

import {
  InputModeType,
  InputType,
  OptionsListType,
} from '../../../utils/@globalTypes';
import {
  FIRST_NAME_REQ,
  LAST_NAME_REQ,
  MIDDLE_NAME_REQ,
} from '../../../utils/constants';
import Input from '../../Input';
import BookingSectionTitle from '../BookingSectionTitle';

import SelectComponent from '../../SelectComponent';

import styles from './BookingPersonBlock.module.scss';
import { FormikProps} from 'formik';

type PersonblockProps = {
  windowType: BookingFormType;
  formik: FormikProps<FormBookingType>;
};

const BookingPersonBlock = ({
  windowType = BookingFormType.view,
  formik,
}: PersonblockProps) => {
  
  const {
    handleChange,
    values,
    errors,
    setFieldTouched,
    validateField,
    touched,
  } = formik;
  const countriesList: OptionsListType = Object.entries(ru).map(
    ([value, label]) => ({
      value,
      label,
    }),
  );
  
  
  useEffect(() => {
    if (touched.last_name) {
      validateField('last_name');
    }
  }, [touched, values]);

  useEffect(() => {
    if (touched.first_name) {
      validateField('first_name');
    }
  }, [touched, values]);

  useEffect(() => {
    if (touched.second_name && values.second_name) {
      if (values?.second_name.length > 0) {
        validateField('second_name');
      } else formik.setFieldError('second_name', '');
    }
  }, [touched, values]);

  useEffect(() => {
    if (touched.nationality) {
      validateField('nationality');
    }
  }, [touched, values]);

  return (
    <div className={styles.wrap}>
      <BookingSectionTitle title="Личная информация" />
      <div className={styles.container}>
        <div className={styles.leftColumn}>
          <Input
            id="last_name"
            value={values.last_name}
            title={windowType === BookingFormType.view ? 'Фамилия' : 'Фамилия*'}
            disabled={windowType === BookingFormType.view ? true : false}
            name="last_name"
            placeholder="Введите фамилию"
            type={InputType.TEXT}
            inputMode={InputModeType.TEXT}
            errText={
              windowType === BookingFormType.view
                ? undefined
                : errors.last_name
                  ? errors.last_name
                  : undefined
            }
            className={styles.booking}
            containerClassName={styles.inputСontainer}
            onChange={handleChange('last_name')}
            requirementsText={
              windowType === BookingFormType.view ? undefined : LAST_NAME_REQ
            }
            isBooking={true}
            onBlur={() => setFieldTouched('last_name')}
            banSymbols={/\s/g}
            autoComplete="family-name"
          />
          <Input
            id="first_name"
            value={values.first_name}
            title={windowType === BookingFormType.view ? 'Имя' : 'Имя*'}
            disabled={windowType === BookingFormType.view ? true : false}
            name="first_name"
            placeholder="Введите имя"
            type={InputType.TEXT}
            inputMode={InputModeType.TEXT}
            errText={
              windowType === BookingFormType.view
                ? undefined
                : errors.first_name
            }
            className={styles.booking}
            containerClassName={styles.inputСontainer}
            onChange={handleChange('first_name')}
            onBlur={() => setFieldTouched('first_name')}
            requirementsText={
              windowType === BookingFormType.view ? undefined : FIRST_NAME_REQ
            }
            isBooking={true}
            banSymbols={/\s/g}
            autoComplete="given-name"
          />
        </div>
        <div className={styles.rightColumn}>
          <Input
            id="second_name"
            value={values.second_name ? values.second_name : ''}
            title="Отчество"
            disabled={windowType === BookingFormType.view ? true : false}
            name="second_name"
            placeholder={
              windowType === BookingFormType.view ? '-' : 'Введите отчество'
            }
            type={InputType.TEXT}
            inputMode={InputModeType.TEXT}
            errText={
              windowType === BookingFormType.view
                ? undefined
                : errors.second_name
            }
            containerClassName={styles.inputСontainer}
            className={styles.booking}
            onChange={handleChange('second_name')}
            onBlur={() => setFieldTouched('second_name')}
            isBooking={true}
            requirementsText={
              windowType === BookingFormType.view ? undefined : MIDDLE_NAME_REQ
            }
            banSymbols={/\s/g}
            autoComplete="additional-name"
          />
          <div className={styles.nationality}>
            <SelectComponent
              id="nationality"
              name="nationality"
              title={
                windowType === BookingFormType.view
                  ? 'Гражданство'
                  : 'Гражданство*'
              }
              optionsList={countriesList}
              currentValue={values.nationality}
              placeholder="Укажите гражданство"
              isSearchable={windowType === BookingFormType.view ? false : true}
              isDisabled={windowType === BookingFormType.view ? true : false}
              setSelecValue={handleChange('nationality')}
              errText={
                windowType === BookingFormType.view
                  ? undefined
                  : errors.nationality
              }
              isBooking={true}
              onBlur={() => setFieldTouched('nationality')}
            />
          </div>         
        </div>
      </div>
    </div>
  );
};

export default BookingPersonBlock;
